import { Breadcrumb } from 'antd';
import React from 'react';
import { withRouter, Router as IRouter } from 'next/router';
import memoizeOne from 'memoize-one';
import { FormattedMsg } from '@components/i18n/formattedMsg';
import Link from 'next/link'

interface IFunderBreadCrumb {
    router: IRouter
}

const SkipQuery = new RegExp(/\[/, 'igm');
const PathPrefix = 'common.bread-crumb';
const HOME_ROUTE = `${PathPrefix}.home`;

const RouteMap = Object.freeze({
    'common.bread-crumb.home': '/',
    'common.bread-crumb.marketplace': '/marketplace',
    'common.bread-crumb.profile': '/profile',
    'common.bread-crumb.balance-asset': '/balance-asset/account-summary'
});

const genPathRouteArray = memoizeOne((path) => {
    const pathRoute = [HOME_ROUTE];
    path
        .split('/')
        .forEach(item => {
            if (item && !SkipQuery.test(item))
                pathRoute.push(`${PathPrefix}.${item}`);
        });

    return pathRoute
        .map((item, index) => {

            const route = RouteMap[item];

            if (route)
                return <Breadcrumb.Item key={index}><Link href={route}><a><FormattedMsg id={item} /></a></Link></Breadcrumb.Item>

            return <Breadcrumb.Item key={index} ><FormattedMsg id={item} /></Breadcrumb.Item>
        })

})

const FunderBreadCrumb: React.FunctionComponent<IFunderBreadCrumb> = props => {
    const { router } = props;
    return (
        <Breadcrumb style={{ cursor: 'default' }}>
            {genPathRouteArray(router.pathname)}
        </Breadcrumb>
    );
}

export default withRouter(FunderBreadCrumb);